import MessageStart from './MessageStart.vue'
export default {
  MessageStart
}



// WEBPACK FOOTER //
// ./src/components/Message/index.js